import ThreeDivesPatternIcon from '../../../../assets/icons/drawingTools/3DivesPattern'
import HeadAndShoulderIcon from '../../../../assets/icons/drawingTools/headAndShoulderPattern'
import ABCDPatternIcon from '../../../../assets/icons/drawingTools/abcdPattern'
import ElliottImpulseWaveIcon from '../../../../assets/icons/drawingTools/elliottImpulseWave'
import ElliottTriangleWaveIcon from '../../../../assets/icons/drawingTools/elliottTriangleWave'
import TrianglePatternIcon from '../../../../assets/icons/drawingTools/trianglePattern'
import XABCDPatternIcon from '../../../../assets/icons/drawingTools/xabcdPattern'
import { DrawingToolMenuItem } from './drawingToolMenu'

export const patternsToolMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'xabcdPattern',
        text: 'XABCD Pattern',
        icon: <XABCDPatternIcon />,
        drawingType: 'xabcdPattern',
        toolOptions: {}
    },
    {
        drawingToolId: 'abcdPattern',
        text: 'ABCD Pattern',
        icon: <ABCDPatternIcon />,
        drawingType: 'abcdPattern',
        toolOptions: {}
    },
    {
        drawingToolId: 'trianglePattern',
        text: 'Triangle Pattern',
        icon: <TrianglePatternIcon />,
        drawingType: 'trianglePattern',
        toolOptions: {}
    },
    {
        drawingToolId: '3DivesPattern',
        text: '3 Dives Pattern',
        icon: <ThreeDivesPatternIcon />,
        drawingType: '3DivesPattern',
        toolOptions: {}
    },
    {
        drawingToolId: 'elliottImpulseWave',
        text: 'Elliott Impulse Wave (12345)',
        icon: <ElliottImpulseWaveIcon />,
        drawingType: 'elliottImpulseWave',
        toolOptions: {}
    },
    {
        drawingToolId: 'elliottImpulseWave',
        text: 'Elliott Triangle Wave (ABCDE)',
        icon: <ElliottTriangleWaveIcon />,
        drawingType: 'elliottImpulseWave',
        toolOptions: {
            triangleWave: true
        }
    },
    {
        drawingToolId: 'headAndShoulderPattern',
        text: 'Head & Shoulder',
        icon: <HeadAndShoulderIcon />,
        drawingType: 'headAndShoulderPattern',
        toolOptions: {}
    }
]